'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationBarTitle = exports.NavigationBarLink = exports.NavigationBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _SegmentLogo = require('./SegmentLogo');

var _SegmentLogo2 = _interopRequireDefault(_SegmentLogo);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale;


var NavigationBarLink = function NavigationBarLink(props) {
  return _react2.default.createElement(_Link2.default, _extends({ primary: false }, (0, _glamor.css)({
    color: _theme2.default.rawColors.blue100,
    '&:hover': {
      color: 'white',
      backgroundColor: _theme2.default.rawColors.blue800
    },
    '&:active, &.active': {
      color: 'white',
      backgroundColor: _theme2.default.rawColors.blue500
    }
  }), props));
};

NavigationBarLink.defaultProps = {
  circle: true,
  textStyle: 'body1',
  paddingX: minorScale(3),
  paddingY: minorScale(1),
  marginX: minorScale(1)
};

var NavigationBarTitle = function NavigationBarTitle(props) {
  return _react2.default.createElement(_Text2.default, props);
};

NavigationBarTitle.defaultProps = {
  is: 'h1',
  textStyle: 'display3',
  bold: true
};

// paddingTop is somewhat of a hack here, but flex will cause the truncate to fail
var NavigationBarLeftTitle = function NavigationBarLeftTitle(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    _Box2.default,
    { marginLeft: majorScale(2), truncate: true, paddingTop: '1px', paddingLeft: majorScale(2), borderLeft: true, borderColor: 'rgba(255,255,255,0.2)' },
    _react2.default.createElement(
      _Text2.default,
      _extends({ is: 'span', textStyle: 'body1' }, props),
      children
    )
  );
};

var NavigationBarLogo = function NavigationBarLogo(props) {
  return _react2.default.createElement(_SegmentLogo2.default, _extends({ marginTop: '-1px', minWidth: '106px', width: '106px' }, props));
};

var NavigationBarPane = function NavigationBarPane(props) {
  return _react2.default.createElement(_Pane2.default, _extends({ alignItems: 'center', dark: true, display: 'flex' }, props));
};

var NavigationBar = function NavigationBar(_ref2) {
  var logo = _ref2.logo,
      left = _ref2.left,
      right = _ref2.right,
      height = _ref2.height,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['logo', 'left', 'right', 'height', 'children']);

  var child = void 0;
  if (typeof children === 'string') {
    child = _react2.default.createElement(
      NavigationBarTitle,
      null,
      children
    );
  } else {
    child = children;
  }

  var leftChild = void 0;
  if (typeof left === 'string') {
    leftChild = _react2.default.createElement(
      NavigationBarLeftTitle,
      null,
      left
    );
  } else {
    leftChild = left;
  }

  return _react2.default.createElement(
    NavigationBarPane,
    _extends({ height: height }, props),
    _react2.default.createElement(
      _Pane2.default,
      { width: '33%', height: '100%', padding: majorScale(2), display: 'flex' },
      logo,
      ' ',
      leftChild
    ),
    _react2.default.createElement(
      _Pane2.default,
      { flexAuto: true, textAlign: 'center' },
      child
    ),
    _react2.default.createElement(
      _Pane2.default,
      { width: '33%', textAlign: 'right', padding: minorScale(3) },
      right
    )
  );
};

NavigationBar.propTypes = {
  logo: _propTypes2.default.node,
  left: _propTypes2.default.node,
  right: _propTypes2.default.node,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  height: _propTypes2.default.string
};

NavigationBar.defaultProps = {
  logo: _react2.default.createElement(NavigationBarLogo, null),
  height: majorScale(7)
};

exports.NavigationBar = NavigationBar;
exports.NavigationBarLink = NavigationBarLink;
exports.NavigationBarTitle = NavigationBarTitle;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/NavigationBar.js
// module id = 1125
// module chunks = 0